import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type"];
import { connect, useSelector } from 'react-redux';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AddWidgetAccordion from 'InpageEditorUI/components/sidebar/add/AddWidgetAccordion';
import SearchResults from './SearchResults';
import { getCategoryDisplayNameByType } from 'ContentEditorUI/redux/selectors/categorizationSelectors';
import { PATAGONIA_ADD_PANEL_SUB_CATEGORIES, PATAGONIA_ADD_PANEL_SUB_CATEGORIES_YAML_MAPPING } from 'ContentEditorUI/constants/Sidebar';
import MobileSidebarOverlayContainer from 'ContentEditorUI/components/sidebar/MobileSidebarOverlayContainer';
import { getSidebarSearchQuery } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getTemplatePath } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getUpgradableModulesWithPQL, getDisabledAddModules } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { renderLazyTileList } from './addWidgetHelpers';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { getPatagoniaAddSidebarSubCategories } from 'ContentEditorUI/redux/selectors/sidebarCategorySelectors';
import useAccordionOpenState from 'ContentEditorUI/hooks/useAccordionOpenState';
// @ts-expect-error not typed
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AccordionTitle = ({
  collectionCount,
  patagoniaAddSidebarSubCategory
}) => {
  const categoryDisplayNameByType = useSelector(getCategoryDisplayNameByType);
  const isAll = patagoniaAddSidebarSubCategory === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.ALL;
  const isTheme = patagoniaAddSidebarSubCategory === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.THEME;
  const isContainers = patagoniaAddSidebarSubCategory === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.BUILDING_BLOCKS.CONTAINERS;
  return /*#__PURE__*/_jsx(Text, {
    as: "span",
    typography: "heading-50",
    children: isAll || isTheme || isContainers ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: PATAGONIA_ADD_PANEL_SUB_CATEGORIES_YAML_MAPPING[`${patagoniaAddSidebarSubCategory}_WITH_COUNT`],
      options: {
        count: collectionCount
      }
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: `${categoryDisplayNameByType[patagoniaAddSidebarSubCategory]} (${collectionCount})`
    })
  });
};
const AddWidgetAccordionWithOpenState = _ref => {
  let {
      type
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const storageKey = `addPanelAccordion-${type}.isOpen`;
  function getInitialOpenState(storedOpenState) {
    return Boolean(type === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.THEME && storedOpenState === null || storedOpenState && storedOpenState === 'true');
  }
  const {
    isOpen,
    handleOpenChange
  } = useAccordionOpenState({
    storageKey,
    getInitialOpenState
  });
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "100",
    marginBlockEnd: "500",
    as: "div",
    children: /*#__PURE__*/_jsx(AddWidgetAccordion, Object.assign({}, rest, {
      type: type,
      open: isOpen,
      onOpenChange: handleOpenChange
    }))
  });
};
const mapStateToProps = state => {
  return {
    categorizedSearchQuery: getSidebarSearchQuery(state),
    patagoniaAddSidebarSubCategories: getPatagoniaAddSidebarSubCategories(state),
    upgradableModules: getUpgradableModulesWithPQL(state),
    disabledModules: getDisabledAddModules(state)
  };
};
const PatagoniaAddWidget = ({
  bus,
  categorizedSearchQuery,
  categoryToModulesSchemasMap,
  categoryToBuildingBlocksMap,
  sidebarSearchResultsMap,
  onDragStart,
  onDragEnd,
  sidebarIframeBody,
  patagoniaAddSidebarSubCategories,
  shouldRenderTourStep,
  upgradableModules,
  disabledModules
}) => {
  var _EditorConfigSingleto, _addSidebarConfig$hid;
  const addSidebarConfig = ((_EditorConfigSingleto = EditorConfigSingleton.get('inpage')) === null || _EditorConfigSingleto === void 0 ? void 0 : _EditorConfigSingleto.addSidebar) || null;
  const defaultSubCategoryMapConfig = (addSidebarConfig === null || addSidebarConfig === void 0 ? void 0 : addSidebarConfig.defaultSubCategoryMap) || null;
  const hideAccordionWithOneSubCategory = (_addSidebarConfig$hid = addSidebarConfig === null || addSidebarConfig === void 0 ? void 0 : addSidebarConfig.hideAccordionWithOneSubCategory) !== null && _addSidebarConfig$hid !== void 0 ? _addSidebarConfig$hid : false;
  // NOTE: filterModules is not applied to search results
  const filterModules = (addSidebarConfig === null || addSidebarConfig === void 0 ? void 0 : addSidebarConfig.filterModules) || null;
  const templatePath = useSelector(getTemplatePath);
  function getCategorizedModules(sidebarSubCategory) {
    const modules = categoryToModulesSchemasMap[sidebarSubCategory] || [];
    if (typeof filterModules === 'function') {
      return filterModules(modules, templatePath);
    }
    return modules;
  }
  function getCategorizedBuildingBlocks(sidebarSubCategory) {
    return categoryToBuildingBlocksMap[sidebarSubCategory] || [];
  }
  let subCategories = patagoniaAddSidebarSubCategories;
  if (defaultSubCategoryMapConfig) {
    var _defaultSubCategoryMa, _defaultSubCategoryMa2;
    subCategories = {
      MODULES: (_defaultSubCategoryMa = defaultSubCategoryMapConfig.MODULES) !== null && _defaultSubCategoryMa !== void 0 ? _defaultSubCategoryMa : subCategories.MODULES,
      BUILDING_BLOCKS: (_defaultSubCategoryMa2 = defaultSubCategoryMapConfig.BUILDING_BLOCKS) !== null && _defaultSubCategoryMa2 !== void 0 ? _defaultSubCategoryMa2 : subCategories.BUILDING_BLOCKS
    };
  }
  return /*#__PURE__*/_jsxs(View, {
    paddingBlock: "500",
    paddingInline: "200",
    position: "relative",
    children: [/*#__PURE__*/_jsx(MobileSidebarOverlayContainer, {
      modalMessageKey: "addModule.mobile.message.addModule",
      contextual: false
    }), !categorizedSearchQuery && /*#__PURE__*/_jsxs(_Fragment, {
      children: [(subCategories.BUILDING_BLOCKS || []).map(patagoniaAddSidebarSubCategory => {
        const collection = getCategorizedBuildingBlocks(patagoniaAddSidebarSubCategory);
        return collection.length > 0 ? /*#__PURE__*/_jsx(AddWidgetAccordionWithOpenState, {
          type: patagoniaAddSidebarSubCategory,
          sidebarIframeBody: sidebarIframeBody,
          collection: collection,
          title: /*#__PURE__*/_jsx(AccordionTitle, {
            collectionCount: collection.length,
            patagoniaAddSidebarSubCategory: patagoniaAddSidebarSubCategory
          }),
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          shouldRenderTourStep: shouldRenderTourStep,
          upgradableModules: upgradableModules,
          disabledModules: disabledModules
        }, patagoniaAddSidebarSubCategory) : null;
      }), (subCategories.MODULES || []).map(patagoniaAddSidebarSubCategory => {
        const collection = getCategorizedModules(patagoniaAddSidebarSubCategory);
        return hideAccordionWithOneSubCategory && subCategories.MODULES.length === 1 ? /*#__PURE__*/_jsx(View, {
          paddingInline: "100",
          as: "div",
          children: collection.length > 0 && renderLazyTileList({
            collection,
            onDragStart,
            onDragEnd,
            type: patagoniaAddSidebarSubCategory,
            sidebarIframeBody,
            shouldRenderTourStep,
            upgradableModules,
            disabledModules
          })()
        }, patagoniaAddSidebarSubCategory) : /*#__PURE__*/_jsx(AddWidgetAccordionWithOpenState, {
          type: patagoniaAddSidebarSubCategory,
          sidebarIframeBody: sidebarIframeBody,
          collection: collection,
          title: /*#__PURE__*/_jsx(AccordionTitle, {
            collectionCount: collection.length,
            patagoniaAddSidebarSubCategory: patagoniaAddSidebarSubCategory
          }),
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          shouldRenderTourStep: shouldRenderTourStep,
          upgradableModules: upgradableModules,
          disabledModules: disabledModules
        }, patagoniaAddSidebarSubCategory);
      })]
    }), categorizedSearchQuery && /*#__PURE__*/_jsx(SearchResults, {
      bus: bus,
      categoryToModulesSchemasMap: categoryToModulesSchemasMap,
      categorizedSearchQuery: categorizedSearchQuery,
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      sidebarIframeBody: sidebarIframeBody,
      sidebarSearchResultsMap: sidebarSearchResultsMap,
      disabledModules: disabledModules
    })]
  });
};
export default connect(mapStateToProps)(PatagoniaAddWidget);